import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { useSSRSafeId as $b5e257d569688ac6$export$619500959fc48b26 } from '../../node_modules/@react-aria/ssr/dist/import.js';
import { componentModalContainerStateEnterActiveTransformTransitionTransitionDuration } from '@livingdesign/tokens/dist/js/light/regular/components/Modal';
import styles from './ModalPortal.module.scss.js';
import { Overlay } from '../Overlay/Overlay.js';
import { OverlayCloseButton } from '../Overlay/OverlayCloseButton.js';
import 'react-dom';
import '@walmart-web/livingdesign-components/index.esm.css';
import { useLockBodyScroll, useOnClickOutside, useOnKeyDown, Caption } from '@walmart-web/livingdesign-components';
import '../Alert/Alert.js';
import '../Button/Button.js';
import '../Button/ButtonGroup.js';
import '../Radio/Radio.js';
import '../Tag/Tag.js';
import '../Checkbox/Checkbox.js';
import '../Chip/Chip.js';
import { applyCommonProps } from '../utility/commonProps.js';
import '../IconButton/IconButton.js';
import '@livingdesign/icons';
import '@livingdesign/tokens/dist/js/light/regular/components/Form';
import '../TextField/TextField.js';
import '../TabNavigation/TabNavigation.js';
import '../TabNavigation/TabNavigationItem.js';
import './Modal.js';
import '@livingdesign/tokens/dist/js/light/regular/components/ErrorMessage';
import '../SearchBox/SearchBox.js';
import '../AutoComplete/AutoComplete.js';
import '../TextArea/TextArea.js';
import '../ProgressIndicator/ProgressIndicator.js';
import '../Panel/Panel.js';
import '../Calendar/locale/wmLocale.js';
import '../Calendar/locale/stdLocale.js';
import '../Calendar/context.js';
import 'dayjs';
import '../Calendar/RenderDays.js';
import '../Calendar/RenderWeeks.js';
import '../components/Popover/Popover.js';
import '../components/InfoUnderline/InfoUnderline.js';
import '../CardActionArea/CardActionArea.js';
import '../HierarchySelector/HierarchySelector.js';
import '../Pagination/Pagination.js';
import '../DisplayTag/DisplayTag.js';
import '../PageHeader/PageHeader.js';
import '../Table/Table.js';
import '../Tooltip/Tooltip.js';
import '../ValueChange/ValueChange.js';
import '../OverlayHeader/OverlayHeader.js';
import { OverlayScrim } from '../Overlay/OverlayScrim.js';
import { invariant } from '../utility/invariant.js';

var _excluded = ["actions", "leftActions", "children", "closeButtonProps", "isOpen", "onClose", "size", "title", "description", "onClosed", "className"],
  _excluded2 = ["onClick"];
/**
 * @private
 */
var ModalPortal = function ModalPortal(props) {
  var _applyCommonProps = applyCommonProps(props, ModalPortal),
    actions = _applyCommonProps.actions,
    leftActions = _applyCommonProps.leftActions,
    children = _applyCommonProps.children,
    closeButtonProps = _applyCommonProps.closeButtonProps,
    isOpen = _applyCommonProps.isOpen,
    onClose = _applyCommonProps.onClose,
    _applyCommonProps$siz = _applyCommonProps.size,
    size = _applyCommonProps$siz === void 0 ? 'small' : _applyCommonProps$siz,
    title = _applyCommonProps.title,
    description = _applyCommonProps.description,
    onClosed = _applyCommonProps.onClosed,
    className = _applyCommonProps.className,
    rest = _objectWithoutProperties(_applyCommonProps, _excluded);
  invariant(!!title, 'Required property `title` not provided.');
  var _ref = closeButtonProps || {},
    closeButtonOnClick = _ref.onClick,
    closeButtonRest = _objectWithoutProperties(_ref, _excluded2);
  var modalRef = React.useRef(null);
  var _useLockBodyScroll = useLockBodyScroll(),
    _useLockBodyScroll2 = _slicedToArray(_useLockBodyScroll, 1),
    setScrollableContentElement = _useLockBodyScroll2[0];
  var titleId = $b5e257d569688ac6$export$619500959fc48b26();
  useOnClickOutside(modalRef, onClose);
  useOnKeyDown(['Esc', 'Escape'], onClose);
  return /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: {
      enter: styles.transitionEnter,
      enterActive: styles.transitionEnterActive,
      exit: styles.transitionExit,
      exitActive: styles.transitionExitActive
    },
    "in": isOpen,
    mountOnEnter: true,
    onExited: function onExited() {
      return onClosed === null || onClosed === void 0 ? void 0 : onClosed();
    },
    timeout: componentModalContainerStateEnterActiveTransformTransitionTransitionDuration
  }, /*#__PURE__*/React.createElement(Overlay, _extends({}, rest, {
    UNSAFE_className: className
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    "aria-labelledby": titleId,
    className: classNames(styles.modal, size === 'large' && styles.large, size === 'medium' && styles.medium, size === 'small' && styles.small, size === 'mega' && styles.mega),
    ref: modalRef,
    role: "dialog"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(OverlayCloseButton, _extends({
    onClick: function onClick(event) {
      closeButtonOnClick === null || closeButtonOnClick === void 0 || closeButtonOnClick(event);
      onClose(event);
    }
  }, closeButtonRest)), /*#__PURE__*/React.createElement("h2", {
    className: styles.title,
    id: titleId
  }, title, /*#__PURE__*/React.createElement(Caption, {
    UNSAFE_style: {
      color: '#74767C'
    }
  }, description))), /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    ref: setScrollableContentElement
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contentInner
  }, children)), actions || leftActions ? /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.actions, leftActions !== undefined && styles.leftActions)
  }, leftActions ? leftActions : null, actions ? actions : null) : null)), /*#__PURE__*/React.createElement(OverlayScrim, {
    className: styles.scrim
  })));
};

export { ModalPortal };
